import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { BIODIVERSITY_ATTACHMENT_API } from './config';

export function getList(query) {
  return getFetch(`${BIODIVERSITY_ATTACHMENT_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${BIODIVERSITY_ATTACHMENT_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${BIODIVERSITY_ATTACHMENT_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${BIODIVERSITY_ATTACHMENT_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${BIODIVERSITY_ATTACHMENT_API()}`, obj);
}



// WEBPACK FOOTER //
// ./src/api/biodiversityAttachmentApi.js